import { render } from "./TemplateIsoRadioGroup.vue?vue&type=template&id=599ca152&scoped=true"
import script from "./TemplateIsoRadioGroup.vue?vue&type=script&lang=js"
export * from "./TemplateIsoRadioGroup.vue?vue&type=script&lang=js"

import "./TemplateIsoRadioGroup.vue?vue&type=style&index=0&id=599ca152&lang=less&scoped=true"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599ca152"]])

export default __exports__